import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ProjetcsService } from 'src/app/projects/projetcs.service';
import { BackgroundFilesService, IPendingFile } from 'src/app/shared/services/background-files.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'app-add-file-service',
    templateUrl: './add-file-service.component.html',
    styleUrls: ['./add-file-service.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddFileServiceComponent implements OnInit {
	@Input() shootingId: string;
	@Input() projectId: any;
	@Input() service: any;
	@Input() type: string;
	@Input() cateringList: any[] = [];
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	loading: boolean = false;
	serviceFiles: any = [];
	acceptedFiles: string = '.pdf,.jpg,.jpeg,.png,.xlsx';
	values: any = {
		'caterings': [],
	};

	submitForm() {
		this.loading = true;
		this.addServicesFiles(this.service.id);
	}

	addServicesFiles(id) {
		this.loading = true;
		let fileRequests = [];
		let pendingFiles: IPendingFile[] = [];

		// Adds to pending files
		for (const file of this.serviceFiles) {

			if (this.type == 'service') {
				fileRequests.push(this._pS.addServiceShootingFile(id, file, this.projectId));
			} else if (this.type == 'catering') {
				let caterings = this.values.caterings.map(c => c.id).join(',');
				caterings = `[${caterings}]`;
				fileRequests.push(this._pS.addCateringShootingFile(caterings, file, this.projectId));
			}
			const pendingFile: IPendingFile = {
				'fileName': file.name,
				'action': 'view',
				'taskId': Date.now() + Math.random(),
				'status': 'pending',
			}
			pendingFiles.push(pendingFile);
			this._bgFile.addPendingFile(pendingFile);
		}

		//Multiple requests
		forkJoin(fileRequests).subscribe(
			data => {
				this.changeStatusPendingFiles(pendingFiles, 'complete');
				this.loading = false
				this.notify.emit();
			},
			err => {
				this.changeStatusPendingFiles(pendingFiles, 'failed');
				this.loading = false
				this.notify.emit();
			}
		);
	}

	changeStatusPendingFiles(files, status) {
		for (const pf of files) {
			this._bgFile.changeStatusFile(pf, status);
		}
	}

	newFile(ev) {

	}

	close() {
		this.closeView.emit()
	}

	formIsValid() {
		if (this.type == 'catering') {
			return this.serviceFiles.length && this.values.caterings.length
		}
		return this.serviceFiles.length
	}

	setCateringValues() {
		this.cateringList = this.cateringList.map(c => {
			let hour;

			if (this.shootingId) {
				hour = c.time;
				c.total_cost = c.quantity * c.cost_unit;

				let date = new Date();
				let timesSplit = c.time ? c.time.split(':') : null;
				hour = timesSplit ? this._datePipe.transform(date.setHours(timesSplit[0], timesSplit[1]), 'h:mm a') : '--:-- --';

			} else {
				hour = c.time ? this._gS.getStaticStringHour(c.time) : '--:-- --';
			}
			let quantity = `${this._translatePipe.transform('qty')}: ${c.quantity}`;
			let total = c.total_cost || c.total_cost == 0 ? this._currencyPipe.transform(c.total_cost, '$') : '--';
			c.description = `${this._gS.backTranslate(c, 'catering_name')} ${hour} - ${quantity}, total: ${total}`;
			return c;
		})
		let value = this.cateringList.find(c => c.id == this.service.id)
		this.values.caterings.push(value);
	}

	constructor(private _currencyPipe: CurrencyPipe, private _translatePipe: TranslatePipe, private _datePipe: DatePipe, private _bgFile: BackgroundFilesService, private _pS: ProjetcsService, public _gS: GlobalService) { }

	ngOnInit() {
		if (this.type == 'catering') {
			this.setCateringValues();
		}
	}

}
